import { useState, useEffect, useRef, useContext } from 'react';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { IoCheckmarkCircle, IoCheckmarkCircleOutline } from "react-icons/io5";
//import { ViewerContext } from "../../pages/Viewer";
import { DocViewerContext } from "../../App.js";
import { format, formatISO } from 'date-fns'
export default function FamilyDetails({ familyDetails, employeeDetails }) {

    const {
        docNum, numDocs, prevDocument, nextDocument, fetchBatch, batch, setBatch,
        documentDependentProgress, setDocumentDependentProgress,
        handleProvideDocumentProcessStatusByDependentID, currentAuditId, setCurrentAuditId
    } = useContext(DocViewerContext)

    const [sortedFamily, setSortedFamily] = useState([]); //used to hold sorted family for dependent details (spouse, dependents) when applicable
    const [spouseDetails, setSpouseDetails] = useState([]); //holds spouse details from family details for sorting
    const [dependentDetails, setDependentDetails] = useState([]); //holds dependent details from family details for sorting
    const [sortFamily, setSortFamily] = useState(false); //flags families to be sorted on familyDetails and spouseDetails load.

    useEffect(() => {
        setSortFamily(false);
        setDependentsSorted(false);
    }, [batch, setBatch]);

    useEffect(() => {
        setSortedFamily([]);
        setSpouseDetails([]);
        setDependentDetails([]);
        console.log("current famaily details --- ", familyDetails);
        familyDetails?.map((member) => {

            if (member?.memberId && (member?.memberRelationship?.includes("S") === true || member?.memberRelationship?.includes("DP") === true)) {
                setSpouseDetails(spouseDetails => [...spouseDetails, member]);
            }else if (member?.memberId && member?.memberRelationship?.includes("D") === true) {
                setDependentDetails(dependentDetails => [...dependentDetails, member]);
            }else if (member?.memberId && (member?.memberRelationship.includes("D") !== true && member?.memberRelationship.includes("E") !== true && member?.memberRelationship.includes("S") !== true && member?.memberRelationship?.includes("DP") !== true) && member?.memberRelationship !== null && member?.memberRelationship !== "undefined") {
                setDependentDetails(dependentDetails => [...dependentDetails, member]);
            }

            //if (member?.memberId && member?.memberRelationship?.includes("S") !== true && member?.memberId && member?.memberRelationship?.includes("E") !== true && member?.memberRelationship !== null && member?.memberRelationship !== "undefined") {
            //    setDependentDetails(dependentDetails => [...dependentDetails, member]);
            //}

           

            
        });


        console.log("Family Details - setSortFamily called");
        setSortFamily(true);

    }, [familyDetails, employeeDetails]);


    useEffect(() => {
        console.log("current details for dependents ---", dependentDetails);
    }, [setDependentDetails, dependentDetails]);

  


    const [dependentsSorted, setDependentsSorted] = useState(false);
    //const [finDepList, setFinDepList] = useState([]);

    //useEffect(() => {
    //    console.log("finDepList - ", finDepList);
    //    //setDependentDetails(finDepList);
    //    setDependentsSorted(true);

    //}, [finDepList, setFinDepList]);

    useEffect(() => {

        if (sortFamily === true) {
          
            console.log("map result pre sort --- ", dependentDetails);
            const sortedDependentDetails = [...dependentDetails];
            const mappedDepDetails = sortedDependentDetails?.map((dep, index) => {
                return { index, value: dep };
            });
            //TODO: fix sorting
            mappedDepDetails?.sort((a, b) => {

                const dateA = Date.parse(a?.value?.birthDate);
                const dateB = Date.parse(b?.value?.birthDate);
                console.log("dates ---- ", dateA, " - ", dateB);
                if (dateA < dateB) {
                    return -1;
                }

                if (dateA > dateB) {
                    return 1;
                }

                return 0;

            });

          
            const result = mappedDepDetails?.map((dependent) => sortedDependentDetails[dependent?.index]);
            //sortedDependentDetails = mappedDepDetails?.map((dependent) => { return { dependent?.value }; });
            console.log("map result --- ", result);
            console.log("sorted details -- ", sortedDependentDetails);
            setDependentDetails([]);
            result?.map((dependent) => {
                console.log("dependent from result - ", dependent);
                setDependentDetails(dependentDetails => [...dependentDetails, dependent]);
            });
            //setFinDepList(result);
            setDependentsSorted(true);
        }

    }, [setSortFamily, sortFamily]);




    useEffect(() => {
        //setSortedFamily(sortedFamily => [...sortedFamily, member]);
        if (sortFamily === true && dependentsSorted === true) {
            spouseDetails?.map((spouse) => {
                setSortedFamily(sortedFamily => [...sortedFamily, spouse]);

            });


         
            console.log("dependentDetailsSorted ", dependentDetails);

            dependentDetails?.map((dependent) => {
                setSortedFamily(sortedFamily => [...sortedFamily, dependent]);
            });
            setSortFamily(false);
        }
    }, [setDependentsSorted, dependentsSorted]);
    
    console.log("FamilyDetails - Within Component: ", familyDetails)
    console.log("EmployeeDetails - Within Component: ", employeeDetails)
    console.log(" documentDependentProgress - Within Component: ", documentDependentProgress)
    console.log("family details currentAuditId - ", currentAuditId);

    useEffect(() => {

        console.log("sortedFamilyState - ", sortedFamily);
        console.log("sortedFamilyState sortFamily flag -", sortFamily);
        console.log("sortedFamilyState depdentsSorted - ", dependentsSorted);
        console.log("sortedFamilyState dependentDetails", dependentDetails);

    }, [setSortedFamily, sortedFamily]);

    function renderDate(date) {
        if (!date) {
            return '';
        }
        return format(new Date(date), 'MM/dd/yyyy');
    }

    return (
        <>
            {/* XL DESKTOP VARIANT */}
        <Box sx={{ mt: '-1.5VH', ml: '4.5VW', width: '18.75VW', bgcolor: '#ffffff', height: '86VH', borderLeft: '2px solid #e5e5e5', display: { xs: 'none', md: 'none', xl: 'block' } }}>
        <div>
        {employeeDetails ? (
                    <Box sx={{ width: '18.75VW' }}>
                        <Box sx={{ bgcolor: '#F6F7F8', height: '26px', width: '100%', mb: '0.5VW'   }}>
                            <Typography textAlign="left" fontWeight="700" fontSize="20px" component="div" sx={{ color: '#262626', ml: '0.75VW' }}>

                   Employee Details

                            </Typography>
                        </Box>
                        {/* <Typography variant="h4" gutterbottom>Employee Details</Typography>*/}
                        <Box sx={{ bgcolor: '#FFFFFF', height: '26px', width: '100%',   }}>
                            <Typography fontWeight="600" fontSize="13px" sx={{ color: '#262626', ml: '0.75VW' }}> {employeeDetails[0]?.firstName + " " + employeeDetails[0]?.lastName}</Typography>
                        </Box>
                        {/*<Box sx={{ bgcolor: '#FFFFFF', height: '26px', width: '100%', }}>*/}
                        {/*    <Typography fontWeight="600" fontSize="13px" sx={{ color: '#000000', ml: '0.75VW' }}> {employeeDetails[0]?.lastName}</Typography>*/}
                            {/*</Box>*/}
                         <Box sx={{ display: 'grid', gap: 1, gridTemplateColumns: 'repeat(2, 2fr)', mt: '1VH'}}>
                             <Box justifyContent="flex-start" alignContent="center" sx={{ height: '26px', width: '100%', gridColumn: 'span 1'}}>
                                <Typography fontWeight="600" fontSize="12px" sx={{ color: '#262626', ml: '0.75VW' }}> {'DOB: ' + renderDate(employeeDetails[0]?.birthDate)}</Typography>
                            </Box>
                            <Box justifyContent="flex-end" sx={{ width: '100%', gridColumn: 'span 1'}}>
                                    {currentAuditId ? (
                                        <Box>
                                            <Chip size="small" label={
                                                <Typography fontWeight="900" fontSize="12px"> {currentAuditId}</Typography>
                                            } />
                                        </Box>
                                    ) : (<></>)}
                            </Box>
                               
                        </Box>
                        <Box sx={{ bgcolor: '#FFFFFF', height: '26px', width: '100%',  }}>
                            <Typography fontWeight="600" fontSize="13px" sx={{ color: '#666666', ml: '0.75VW' }}> {employeeDetails[0]?.addressPre + " " + employeeDetails[0]?.address1}</Typography>
                        </Box>
                        <Box sx={{ bgcolor: '#FFFFFF', height: '26px', width: '100%', }}>
                            <Typography fontWeight="600" fontSize="13px" sx={{ color: '#666666', ml: '0.75VW' }}>   {employeeDetails[0]?.address2 + employeeDetails[0]?.city + ", " + employeeDetails[0]?.state + " " + employeeDetails[0]?.zip}</Typography>
                        </Box>
                      {/*  <Divider variant="middle" component="div" />*/}
                            {/*  <Typography variant="body1" gutterbottom>Name: {employeeDetails[0]?.firstName + " " + employeeDetails[0]?.lastName}</Typography>*/}
            {/*   <Typography variant="body1" gutterbottom>Address: {employeeDetails[0]?.addressPre + " " + employeeDetails[0]?.address1 + ". " + employeeDetails[0]?.address2 + ", " + employeeDetails[0]?.city + ", " + employeeDetails[0]?.state + " " + employeeDetails[0]?.zip}</Typography>*/}

                        </Box>) : (<></>)}
        {sortedFamily ? (
                    <Box sx={{ width: '18.75VW' }}>
                        <Box sx={{ bgcolor: '#F6F7F8', height: '26px', width: '100%', mb: '0.5VW'  }}>
                            <Typography textAlign="left" fontWeight="700" fontSize="20px" component="div" sx={{ color: '#262626', ml: '0.75VW' }}>

                                 Dependent Details

                            </Typography>
                        </Box>
           {/* <Typography variant="h4" gutterbottom>Dependent Details</Typography>*/}
            {/* {console.log(familyDetails)} */}
            {sortedFamily?.map((dependent) => {
                if(dependent?.auditId){
                    return(<></>);
                }
                else if(dependent?.familyId){
                    return(<></>);
                }else if(dependent?.memberId){
                    return(
                        <Box sx={{ width: '18.75VW' }}>
                            <Box sx={{ bgcolor: '#FFFFFF', height: '26px', width: '100%',  }}>
                                <Typography fontWeight="600" fontSize="13px" sx={{ color: '#262626', ml: '0.75VW' }}> {dependent?.firstName + " " + dependent?.lastName}</Typography>
                            </Box>
                            {/*<Box sx={{ bgcolor: '#FFFFFF', height: '26px', width: '100%', }}>*/}
                            {/*    <Typography fontWeight="600" fontSize="13px" sx={{ color: '#666666', ml: '0.75VW' }}> {dependent?.lastName}</Typography>*/}
                            {/*</Box>*/}
                            <Box sx={{ height: '26px', width: '100%' }}>
                                <Typography fontWeight="600" fontSize="13px" sx={{ color: '#262626', ml: '0.75VW' }}> {'DOB: ' + renderDate(dependent?.birthDate)}</Typography>
                            </Box>
                            <Box sx={{ display: 'grid', gap: 1, gridTemplateColumns: 'repeat(2, 0.1fr)'}}>
                                <Box sx={{ width: "5%", ml: '0.5VW', height: '26px'}}>
                                {handleProvideDocumentProcessStatusByDependentID(dependent?.memberId) == 1 ? (<>
                                    <IoCheckmarkCircle className="dependentIndicator" />
                                </>) : (<>
                                    <IoCheckmarkCircleOutline className="dependentIndicator--unfilled" />
                                </>)}
                                </Box>
                           
                                <Box sx={{ bgcolor: '#FFFFFF', height: '26px', width: '95%', ml: '0.05VW'  }}>
                                    {/*  <Typography fontWeight="600" fontSize="14px" sx={{ color: '#262626' }}>Relationship: {dependent?.memberRelationship}</Typography>*/}
                                    {/*TODO add another conditional for D as Dependent (Ternary), everything else is defaultCase (set a debug value)*/}
                                    <Box sx={{width: '8VW'}}>
                                        {/*<Typography fontWeight="600" fontSize="13px" sx={{ color: '#666666', ml: '0.75VW' }}>{dependent?.memberRelationship ==*/}
                                        {/*    "S " ? 'Spouse' : 'Dependent'}</Typography>*/}
                                        <Typography fontWeight="600" fontSize="13px" sx={{ color: '#666666', ml: '0.75VW' }}>{dependent?.memberRelationship == "S " ? ('Spouse') : (dependent?.memberRelationship == "DP" ? ('Domestic Partner') : ('Dependent'))}</Typography>
                                    </Box>
                              
                                    {/*<Box sx={{ width: '3VW', ml: 0, mr: 0, mt: 0, mb: 0 }}>*/}
                                    {/*    <IoCheckmarkCircle className="dependentIndicator" />*/}
                                    {/*</Box>*/}
                                </Box>
                           </Box>
                            <Divider variant="middle" component="div" />
                            {/*<Typography variant="body1" gutterbottom>Name: {dependent?.firstName + " " + dependent?.lastName}</Typography>*/}
                            {/*<Typography variant="body1" gutterbottom>Relationship: {dependent?.memberRelationship}</Typography>*/}
                  
                           
                                {/*<Typography variant="body1" gutterbottom>Address: {dependent?.addressPre + " " + dependent?.address1 + ". " + dependent?.address2 + ", " + dependent?.city + ", " + dependent?.state + " " + dependent?.zip}</Typography>*/}

                          
                         
                      </Box>
                    );
                }
            }
              
            )}
        </Box>) : (<></>)}
            </div>
        </Box>

            {/* SM and MD DESKTOP VARIANT */}
            <Box sx={{ mt: '-1.5VH', ml: '2.75VW', width: '22.75VW', bgcolor: '#ffffff', height: '86VH', borderLeft: '2px solid #e5e5e5', display: { xs: 'block', md: 'block', xl: 'none' } }}>
                <div>
                    {employeeDetails ? (
                        <Box sx={{ width: '22.75VW' }}>
                            <Box sx={{ bgcolor: '#F6F7F8', height: '25%', width: '100%', mb: '0.5VW' }}>
                                <Typography textAlign="left" fontWeight="700" fontSize="20px" component="div" sx={{ color: '#262626', ml: '0.75VW' }}>

                                    Employee Details

                                </Typography>
                            </Box>
                            {/* <Typography variant="h4" gutterbottom>Employee Details</Typography>*/}
                            <Box sx={{ bgcolor: '#FFFFFF', height: '26px', width: '100%', }}>
                                <Typography fontWeight="600" fontSize="12px" sx={{ color: '#262626', ml: '0.75VW' }}> {employeeDetails[0]?.firstName + " " + employeeDetails[0]?.lastName}</Typography>
                               {/* <Typography fontWeight="600" fontSize="12px" sx={{ color: '#262626', ml: '0.75VW' }}> {'DOB: ' + renderDate(employeeDetails[0]?.birthDate)}</Typography>*/}
                                <Box sx={{ display: 'grid', gap: 1, gridTemplateColumns: 'repeat(2, 2fr)', mt: '0.2VH' }}>
                                    <Box justifyContent="flex-start" alignContent="center" sx={{ height: '26px', width: '100%', gridColumn: 'span 1' }}>
                                        <Typography fontWeight="600" fontSize="12px" sx={{ color: '#262626', ml: '0.75VW' }}> {'DOB: ' + renderDate(employeeDetails[0]?.birthDate)}</Typography>
                                    </Box>
                                    <Box justifyContent="flex-end" sx={{ width: '100%', gridColumn: 'span 1' }}>
                                        {currentAuditId ? (
                                            <Box>
                                                <Chip size="small" label={
                                                    <Typography fontWeight="900" fontSize="12px"> {currentAuditId}</Typography>
                                                } />
                                            </Box>
                                        ) : (<></>)}
                                    </Box>

                                </Box>
                            </Box>
                            <Box sx={{ height: '26px', width: '100%' }}>
                             
                            </Box>
                            {/*<Box sx={{ bgcolor: '#FFFFFF', height: '26px', width: '100%', }}>*/}
                            {/*    <Typography fontWeight="600" fontSize="13px" sx={{ color: '#000000', ml: '0.75VW' }}> {employeeDetails[0]?.lastName}</Typography>*/}
                            {/*</Box>*/}
                            <Box sx={{ height: '1.25VH'}}></Box>

                            <Box sx={{ bgcolor: '#FFFFFF', height: '26px', width: '100%', }}>
                                <Typography fontWeight="600" fontSize="12px" sx={{ color: '#666666', ml: '0.75VW' }}> {employeeDetails[0]?.addressPre + " " + employeeDetails[0]?.address1}</Typography>
                            </Box>
                            <Box sx={{ bgcolor: '#FFFFFF', height: '26px', width: '100%', }}>
                                <Typography fontWeight="600" fontSize="12px" sx={{ color: '#666666', ml: '0.75VW' }}>   {employeeDetails[0]?.address2 + employeeDetails[0]?.city + ", " + employeeDetails[0]?.state + " " + employeeDetails[0]?.zip}</Typography>
                            </Box>
                            {/*  <Divider variant="middle" component="div" />*/}
                            {/*  <Typography variant="body1" gutterbottom>Name: {employeeDetails[0]?.firstName + " " + employeeDetails[0]?.lastName}</Typography>*/}
                            {/*   <Typography variant="body1" gutterbottom>Address: {employeeDetails[0]?.addressPre + " " + employeeDetails[0]?.address1 + ". " + employeeDetails[0]?.address2 + ", " + employeeDetails[0]?.city + ", " + employeeDetails[0]?.state + " " + employeeDetails[0]?.zip}</Typography>*/}

                        </Box>) : (<></>)}
                    {sortedFamily ? (
                        <Box sx={{ width: '22.75VW' }}>
                            <Box sx={{ bgcolor: '#F6F7F8', height: '25%', width: '100%', mb: '0.5VW' }}>
                                <Typography textAlign="left" fontWeight="700" fontSize="20px" component="div" sx={{ color: '#262626', ml: '0.75VW' }}>

                                    Dependent Details

                                </Typography>
                            </Box>
                            {/* <Typography variant="h4" gutterbottom>Dependent Details</Typography>*/}
                            {/* {console.log(familyDetails)} */}
                            {sortedFamily?.map((dependent) => {
                                if (dependent?.auditId) {
                                    return (<></>);
                                }
                                else if (dependent?.familyId) {
                                    return (<></>);
                                } else if (dependent?.memberId){
                                    return (
                                        <Box sx={{ width: '22.75VW' }}>
                                            <Box sx={{ bgcolor: '#FFFFFF', height: '26px', width: '100%'}}>
                                                <Typography fontWeight="600" fontSize="12px" sx={{ color: '#262626', ml: '0.75VW' }}> {dependent?.firstName + " " + dependent?.lastName}</Typography>
                                                <Typography fontWeight="600" fontSize="12px" sx={{ color: '#262626', ml: '0.75VW' }}> {'DOB: ' + renderDate(dependent?.birthDate)}</Typography>
                                            </Box>
                                            <Box sx={{ height: '26px', width: '100%' }}>
                                              
                                            </Box>
                                            <Box sx={{ height: '1.25VH' }}></Box>
                                            <Box sx={{ display: 'grid', gap: 1, gridTemplateColumns: 'repeat(2, 0.1fr)' }}>
                                                <Box sx={{ width: "5%", ml: '0.5VW', height: '26px' }}>
                                                    {handleProvideDocumentProcessStatusByDependentID(dependent?.memberId) == 1 ? (<>
                                                        <IoCheckmarkCircle className="dependentIndicator" />
                                                    </>) : (<>
                                                        <IoCheckmarkCircleOutline className="dependentIndicator--unfilled" />
                                                    </>)}
                                                </Box>
                                                <Box sx={{ bgcolor: '#FFFFFF', height: '26px', width: '95%',ml: '1VW'  }}>
                                               
                                                    {/*TODO add another conditional for D as Dependent (Ternary), everything else is defaultCase (set a debug value)*/}
                                                    <Typography fontWeight="600" fontSize="12px" sx={{ color: '#666666', ml: '0.75VW' }}>{dependent?.memberRelationship == "S " ? ('Spouse') : (dependent?.memberRelationship == "DP" ? ('Domestic Partner') : ('Dependent'))}</Typography>
                                                </Box>
                                            </Box>
                                            <Divider variant="middle" component="div" />
                                         



                                        </Box>
                                    );
                                }
                            }

                            )}
                        </Box>) : (<></>)}
                </div>
            </Box>
        </>
            );

}